import classNames from 'classnames';
import React from 'react';

import {FormattedCurrency} from '@udemy/react-merchandising-components';

import styles from '../total-price/total-price.module.less';

interface FullPriceSummaryCreditTotalProps {
    remainingCredit: number;
    chargePrice: number;
    isSubtotalLabel: boolean;
}

export const FullPriceSummaryCreditTotal: React.FC<FullPriceSummaryCreditTotalProps> = ({
    remainingCredit,
    chargePrice,
    isSubtotalLabel,
}) => {
    return (
        <div className={styles['credit-total-container']}>
            <div className={styles.item}>
                <span className={classNames(styles['item-title'], 'ud-heading-sm')}>
                    {isSubtotalLabel ? gettext('Subtotal:') : gettext('Total:')}
                </span>
                <span className={classNames(styles['full-credit-total-price'], 'ud-heading-lg')}>
                    <FormattedCurrency value={chargePrice} />
                </span>
            </div>
            <div className={classNames(styles.item, 'ud-text-sm')}>
                <span className={styles['item-title']}>{gettext('Credits Left:')}</span>
                <FormattedCurrency value={remainingCredit} />
            </div>
        </div>
    );
};
